import React, {useContext, useEffect} from 'react';
import {Button} from 'antd';
import DeleteComponent from '../common/DeleteComponent';
import EditComponent from '../common/EditComponent';
import {Arguments} from '../common/Arguments';
import {sideMenuContext} from '../../../router/IndexRouter';
import {GetApiMethod} from '../common/ApiMethod';
import TableComponent from '../common/TablePaginationComponent';

export default function YearlyInspection(props) {
	const currentUrl = window.location.href;
	const {dataSource, setDataSource, setCopyDataSource} = useContext(sideMenuContext);
	const getApi = Arguments.host + '/society_organization/society/api!yearlyRecognition.do';

	useEffect(() => {
		setDataSource([]);
		GetApiMethod({getApi, setDataSource, setCopyDataSource});
	}, [getApi]);

	const columns = [
		{
			title: '序号',
			dataIndex: 'showIndex',
			width: 100,
			sorter: (a, b) => a.showIndex - b.showIndex,
			sortDirections: ['ascend', 'descend'],
		},
		{
			title: '年检年度',
			dataIndex: 'year',
		},
		{
			title: '公示状态',
			dataIndex: 'publicShowState',
		},
		{
			title: '操作',
			width: 140,
			render: (item) => (
				<>
					<EditComponent item={item} url={currentUrl}/>
					<DeleteComponent
						item={item}
						postApi={[Arguments.host + '/society_organization/society/api!addYearlyRecognition.do']}
						getApi={getApi}
					/>
				</>
			),
		},
	];

	const indexDataSource = dataSource.map((data, index) => ({showIndex: index + 1, ...data}));

	return (
		<>
			<Button type="primary" onClick={() => props.history.push('/society/yearly-inspection/add')}
					style={{marginBottom: 10}}>新增</Button>
			<TableComponent dataSource={indexDataSource} columns={columns}/>
		</>
	);
}

